function truncateName(Name) {
  return Name.length >= 12 ? Name.slice(0, 8) + "..." : Name;
}

export default truncateName;
